module.exports = __webpack_public_path__ + "static/img/qiangcha.6e7137e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/qiangcha.png
// module id = rDhs
// module chunks = 24